// extracted by mini-css-extract-plugin
module.exports = {"cardBorder":"Index_cardBorder__22SoK","cardContainer":"Index_cardContainer__2kUvP","chatTab":"Index_chatTab__3ZbtL"};